import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';

import { HisUiService } from '../../../core/service/base/his-ui.service';
import { HisNotificationService } from '../../../core/service/notifications/his-notification.service';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { FormControl } from '@angular/forms';
import { AutoComplete, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { SelectItem } from 'primeng/api';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
          <p-autoComplete #content
            [hisDdKey]="options.ddKey"
            [formControl]="inlineFilter"
            [suggestions]="inlineFilteredCustomOptions"
            [dropdown]="true"
            [forceSelection]="true"
            field="label"
            (completeMethod)="search($event)"
            (onSelect)="onSelect($event)">
          </p-autoComplete>
        
          <p-dialog
            appendTo="body"
            showEffect="fade"
            [(visible)]="multiselectPopupVisible" [responsive]="true" [modal]="true" [dismissableMask]="true" [blockScroll]="true"
            (onHide)="hideMultiselectPopup()" [focusTrap]="true"
			[header]="('multiselectPlam.selectValues' | hisUi) + ' ' + options.label">
            <div class="floatLeft"></div>
            <div class="tableFilterEditBlock">
              @if (showTableFilter) {
                <span>
                  <button class="transparent hideOnMobile" (click)="toggleFilter(); $event.preventDefault();"
                    hisImage="FILTER">
                    <span>
                      {{(toggleTableFilter) ? ('de.his.faces.tags.table.tableFilter.disable' | hisUi) :
                      ('de.his.faces.tags.table.tableFilter.enable' | hisUi)}}
                    </span>
                  </button>
                </span>
              }
            </div>
            <div class="clearerSpaceAboveHalfEm"></div>
            <p-table #selectTable
              [value]="overlayFilteredCustomOptions"
              [paginator]="true"
              [selectionPageOnly]="true"
              [rows]="pageSize"
              [(first)]="firstResultRow"
              [(selection)]="selectedRows"
              (onPage)="onPage($event); selectTable?.el?.nativeElement?.scrollIntoView(({block: 'start', behavior: 'smooth'}));">
              <ng-template pTemplate="header">
                <tr>
                  <th class="multiSelectColumn">
                    <p-tableHeaderCheckbox class="hideOnBreakpointSmall"
                      title="{{'genericSearch.selectAllOfPage' | hisUi}}">
                    </p-tableHeaderCheckbox>
                    <span class="hideOnBreakpointLarge">{{'genericSearch.rowselect' | hisUi}}</span>
                  </th>
                  <th [pSortableColumn]="'label'">
                    {{options.label}}
                    @if (toggleTableFilter) {
                      <div>
                        <input #content [title]="'genericSearch.resultTable.tableFilter.applyFilter' | hisUi"
                          pInputText type="text" [formControl]="overlayFilter"
                          (keydown.enter)="$event.stopPropagation(); onFilterTable()"
                          (click)="$event.stopPropagation();"/>
                      </div>
                    }
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td class="multiSelectColumn">
                    <p-tableCheckbox (click)="$event.preventDefault();"
                      [value]="row" title="{{'genericSearch.selectItems' | hisUi}}"
                      tabindex="0" ariaLabel="{{'genericSearch.selectItems' | hisUi}}">
                    </p-tableCheckbox>
                  </td>
                  <td>{{row.label}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorright">
                <div  class="tableRowCount">
                  <span>
                    {{'de.his.faces.tags.table.datascroller.numRowsFound.label' | hisUi}}
                    {{i18nKeyForRecords | hisUi: totalRowCount}} |
                    @if (totalNumberOfPages > 1) {
                      {{'de.his.faces.tags.table.datascroller.numRowsFound.page'
                      | hisUi: currentPageNumber: totalNumberOfPages }} |
                    }
                    <label for="tableRow">
                      @if (maxRows) {
                        <span>
                          {{'de.his.faces.tags.table.datascroller.numRowsPerPage' | hisUi}} (Max:{{maxRows}})
                        </span>
                      }
                    </label>
                    <input #content [formControl]="maxTableRows" required class="input_3_Chars tableRowInput"
                      (keydown.enter)="$event.stopPropagation(); calculateTotalNumberOfPages()"
                      (click)="$event.stopPropagation();">
                  </span>
                </div>
              </ng-template>
            </p-table>
            <ng-template #footer>
              <button type="submit" iconPos="left" hisImage="TICK" class="button_highlighted marginRightStandard"
                (click)="submitSelection(); hideMultiselectPopup(); $event.preventDefault();">
                <span style="vertical-align: middle">{{'genericSearch.returnSelected' | hisUi}}</span>
              </button>
              <button type="submit" iconPos="left" hisImage="RED_X" class="button_highlighted blue"
                (click)="hideMultiselectPopup(); $event.preventDefault();">
                <span style="vertical-align: middle">{{'genericSearch.backToParentSearch' | hisUi}}</span>
              </button>
            </ng-template>
          </p-dialog>
        
          @if (!true) {
            <ng-container class="selectedOptionsList">
              @if (selectedOptions && selectedOptions.length > 0) {
                <p-dataView #content
                  [hisDdKey]="options.ddKey" [formControl]="formControl"
                  [value]="selectedOptions" [emptyMessage]="'&nbsp;'">
                  <ng-template let-selectedOptions #list>
                    <div class="p-grid p-grid-nogutter">
                      <ul>
                        @for (selectedOption of selectedOptions; track selectedOption; let index = $index) {
                          <li class="selectedDataRow">
                            {{selectedOption.label}}
                            @if (!options.disabled) {
                              <button type="submit"
                                (click)="deleteSelectedOption(index)"
                                hisImage="PANEL_CLOSE" class="icon deleteSelectedOption"
                                title="{{'common.removeAssignmentOf' | hisUi:selectedOption.label}}">
                              </button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                </p-dataView>
              }
            </ng-container>
          }
          @if (true) {
            <ng-container class="selectedOptionsListWithSelection">
              @if (selectedOptions && selectedOptions.length > 0) {
                <p-dataView #content
                  [hisDdKey]="options.ddKey" [formControl]="formControl" styleClass="selectedDataContainer"
                  [value]="selectedOptions" [emptyMessage]="'&nbsp;'">
                  <ng-template let-selectedOptions #list>
                    <div class="p-grid p-grid-nogutter">
                      <ul>
                        @for (selectedOption of selectedOptions; track selectedOption; let index = $index) {
                          <li class="selectedDataRow">
                            {{selectedOption.label}}
                            @if (!options.disabled) {
                              <button type="submit"
                                (click)="deleteSelectedOption(index);"
                                hisImage="PANEL_CLOSE" class="icon deleteSelectedOption"
                              title="{{selectedOption.label}}: {{'view.controls.disconnect' | hisUi}}"></button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                </p-dataView>
              }
            </ng-container>
          }
        
          @if (true) {
            <button #inputElement
              type="submit" [disabled]="options.disabled"
              class="transparent selectButton" hisImage="ARROW_RIGHT_FAT" alt=""
              (click)="showMultiselectPopup(); $event.preventDefault();">
              <span>
                {{(selectedOptions?.length > 0) ? ('genericSearch.changeSelectedItems' | hisUi) : ('genericSearch.selectItems' | hisUi)}}
              </span>
            </button>
          }
          @if (true && selectedOptions && selectedOptions.length > 0) {
            <button type="submit"
              class="transparent selectButton" hisImage="PANEL_CLOSE" alt=""
              (click)="deleteAllSelectedOptions(); $event.preventDefault();">
              <span>{{'genericSearch.deleteSelectedItems' | hisUi}}</span>
            </button>
          }
        </his-plam>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class MultiSelectComponent extends HisDynamicFieldBase<string> implements OnInit {
    private notificationService = inject(HisNotificationService);
    private uiService = inject(HisUiService);

    @ViewChild( 'content' ) autoComplete: AutoComplete;
    pageSize = 10;
    maxRows = 300;
    currentPageNumber = 1;
    totalNumberOfPages?: number;
    maxTableRows = new FormControl( this.pageSize );
    firstResultRow = 0;

    options: HisDynamicFieldConfig;
    selectedOptions: SelectItem[] = [];
    selectedRows: SelectItem[] = [];

    multiselectPopupVisible = false;

    inlineFilter = new FormControl( '' );
    overlayFilter = new FormControl( '' );
    toggleTableFilter = true;
    showTableFilter = true;

    inlineFilteredCustomOptions: SelectItem[] = [];
    overlayFilteredCustomOptions: SelectItem[] = [];
    customOptions: SelectItem[] = [];

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }
    get i18nKeyForRecords() {
        return 'de.his.faces.tags.table.datascroller.numRowsFound' + ( this.totalRowCount === 1 ? '.record' : '.records' );
    }
    
    get totalRowCount(): number {
        return this.overlayFilteredCustomOptions.length;
    }
    ngOnInit() {
        super.initFormControl(this.adaptDefaultValue(this.value));
        this.customOptions = this.options.items;
        this.overlayFilteredCustomOptions = this.options.items;
        this.setSelectedOptions( this.options.defaultValue );
    }

    // autocomplete
    search( event: { query: string } ) {
        this.inlineFilteredCustomOptions = this.customOptions.filter(
            item => {
                if (event.query === '' || item.label.toLowerCase().indexOf( event.query.toLowerCase() ) !== -1) {
                    return this.selectedOptions.find( it => it.label === item.label) === undefined;
                }
                return false;
            }
        );
    }

    onSelect( event: AutoCompleteSelectEvent ) {
        this.addSelectedElement( event.value );
    }

    addSelectedElement( selectedElement: SelectItem ) {
        if ( this.selectedOptions.find( selectedOption => selectedOption.value === selectedElement.value ) ) {
            this.notificationService.info(
                this.uiService.translate( 'genericSearch.alreadySelected', selectedElement.label ), 'Info' );
        } else {
            this.selectedOptions = [...this.selectedOptions, selectedElement];
        }
        this.formControl.setValue( this.selectedOptions.map( o => o.value ), { emitEvent: true } );
        this.inlineFilter.setValue( '' );
        this.autoComplete.clear();
    }

    deleteSelectedOption( index: number ) {
        this.selectedOptions.splice( index, 1 );
        this.selectedOptions = [...this.selectedOptions];
        this.formControl.setValue( this.selectedOptions.map( o => o.value ), { emitEvent: true } );
    }

    deleteAllSelectedOptions() {
        this.selectedOptions = [];
        this.selectedRows = [];
        this.formControl.setValue( this.selectedOptions, { emitEvent: true } );
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            //// Replace items. Note that here we must avoid to create a new array object #255241
            //this.customOptions.splice( 0, this.customOptions.length, ...matchingConfig.items );
            // but the above causes a different problem:
            // set new default value(s)
            this.customOptions = [...matchingConfig.items];
            this.search( { query: '' } );
            this.overlayFilteredCustomOptions = this.customOptions;
            let adaptedValue = this.adaptDefaultValue( matchingConfig.defaultValue );
            this.formControl.setValue( adaptedValue, { emitEvent: false } );
            this.setSelectedOptions( matchingConfig.defaultValue );
        }
    }

    private adaptDefaultValue( value: any ): Array<string> {
        if ( Array.isArray( value ) ) {
            return value;
        } else if ( value && value !== null && value !== '' ) {
            return [value];
        }
        return [];
    }

    private setSelectedOptions( defaultValue: string[] ) {
        this.selectedOptions = [];
        if ( defaultValue ) {
            this.adaptDefaultValue( defaultValue ).forEach( ( value: string ) => {
                this.customOptions.find( ( item: SelectItem ) => {
                    if ( item.value === value.trim() ) {
                        this.selectedOptions.push( item );
                    }
                } );
            } );
        }
    }

    getControlValue(): any {
        return this.formControl.value ? ( this.formControl.value as string[] ).join( ',' ) : '';
    }

    showMultiselectPopup() {
        this.inlineFilter.setValue( '' );
        this.selectedRows = ( this.selectedOptions ) ? this.selectedOptions.slice( 0 ) : [];
        for ( let selectedRow of this.selectedRows ) {
            for ( let element of this.overlayFilteredCustomOptions ) {
                if ( element.value === selectedRow.value ) {
                    this.overlayFilteredCustomOptions.splice( this.overlayFilteredCustomOptions.indexOf( element ), 1, selectedRow );
                }
            }
        }
        this.calculateTotalNumberOfPages();
        this.multiselectPopupVisible = !this.multiselectPopupVisible;
    }

    hideMultiselectPopup() {
        this.multiselectPopupVisible = false;
    }

    submitSelection() {
        this.selectedOptions = [];
        for ( let row of this.selectedRows ) {
            this.addSelectedElement( row );
        }
        this.formControl.setValue( this.selectedOptions.map( o => o.value ), { emitEvent: true } );
    }

    toggleFilter() {
        this.toggleTableFilter = !this.toggleTableFilter;

        if ( !this.toggleTableFilter ) {
            this.overlayFilter.setValue( '' );
            this.onFilterTable();
        }
    }

    onFilterTable() {
        if ( this.overlayFilter.value ) {
            this.overlayFilteredCustomOptions = [];
            for ( let element of this.customOptions ) {
                if ( element.label?.toUpperCase().indexOf( this.overlayFilter.value.toUpperCase() ) > -1 ) {
                    this.overlayFilteredCustomOptions = [...this.overlayFilteredCustomOptions, element];
                }
            }
            this.calculateTotalNumberOfPages();
        }
        else {
            this.overlayFilteredCustomOptions = this.customOptions;
            this.calculateTotalNumberOfPages();
        }
    }

    calculateTotalNumberOfPages() {
        if ( this.maxTableRows && this.maxTableRows.value > 0 || this.maxTableRows.value > this.maxRows ) {
            this.pageSize = +this.maxTableRows.value;
        }
        this.maxTableRows.setValue( this.pageSize );
        this.totalNumberOfPages = Math.ceil( this.overlayFilteredCustomOptions.length / this.pageSize );
    }

    onPage( event: any ) {
        this.pageSize = +this.maxTableRows.value;
        this.firstResultRow = event.first;
        this.currentPageNumber = 1 + this.firstResultRow / this.pageSize;
    }
}
